import { render } from "./PattyStatement.vue?vue&type=template&id=3be57086&scoped=true"
import script from "./PattyStatement.vue?vue&type=script&lang=js"
export * from "./PattyStatement.vue?vue&type=script&lang=js"

import "./PattyStatement.vue?vue&type=style&index=0&id=3be57086&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be57086"]])

export default __exports__